import React from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import OwnerTransfer from '../modules/Auth/pages/OwnerTransfer'
import ResetPassword from '../modules/Auth/pages/ResetPassword'
import UserVerified from '../modules/Auth/pages/UserVerified'
import { Switch } from "react-router-dom";
import { ContentRoute } from '../../_metronic/layout'

export default function Verification() {
    return (
        <>
            <div className="d-flex flex-column flex-root">
                <div
                    className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                    id="kt_login"
                >
                    <div
                        className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
                        style={{
                            backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-15.jpg")})`,
                        }}
                    >
                        <div className="d-flex flex-row-fluid flex-column justify-content-between">
                            <div className=" mx-auto my-auto text-center">
                                <img
                                    alt="Logo"
                                    className="max-h-150px"
                                    src={toAbsoluteUrl("/media/logos/SmartTouchLogo.svg")}
                                />
                                <div className="font-size-h1 mt-5 text-primary">
                                </div>
                            </div>
                            <div className="d-none mx-auto flex-column-auto d-lg-flex justify-content-between mt-10">
                                <div className="opacity-70 font-weight-bold	">
                                    &copy; 2021 Smart Touch
                                      </div>
                                <div className="d-flex">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">

                        <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                            <Switch>
                                <ContentRoute path="/verification/owner-transfer/:id" component={OwnerTransfer} />
                                <ContentRoute path="/verification/reset-password/:id" component={ResetPassword} />
                                <ContentRoute path="/verification/verify-account/:id" component={UserVerified} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
